import { Box, Tooltip } from "@mui/material";
import React from "react";
import { allowedToUpdateEntity } from "src/constants/role";
import { dataStateType } from "src/constants/status";
import { useGetPermissionAccessControl } from "src/context/PermissionAccessControl";
import useAuth from "src/hooks/useAuth";
import { customerColumns as columns, statusOption } from "../../Helper";
import Controls from "src/components/form/controls/Controls";

const GetCustomerColumns = ({ handleSyncData, handleChangeStatus, handlePopupShowDevice, status }) => {
  const { auth } = useAuth();
  const permissionsAccessControl = useGetPermissionAccessControl();

  const customerStatus = {
    key: "status",
    label: "Status",
    align: "center",
    render: (item) => (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          minWidth: "120px",
        }}
      >
        {allowedToUpdateEntity(auth?.permissions, permissionsAccessControl) && (
          <Controls.Select
            name="status"
            value={!item.isDisabled ? "active" : "block"}
            onChange={handleChangeStatus(item)}
            options={statusOption}
          />
        )}
      </Box>
    ),
  };

  const actionCol = {
    key: "actions",
    label: "Actions",
    align: "center",
    render: (item) => (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          minWidth: "120px",
        }}
      >
        <Tooltip title="Đồng Bộ Dữ Liệu">
          {allowedToUpdateEntity(
            auth?.permissions,
            permissionsAccessControl
          ) ? (
            <button
              onClick={() => handleSyncData(item)}
              className="btn btn-warning"
            >
              <i className="bx bx-sync"></i>
            </button>
          ) : (
            <></>
          )}
        </Tooltip>

        <Tooltip title="Hiển thị thiết bị">
          {allowedToUpdateEntity(
            auth?.permissions,
            permissionsAccessControl
          ) ? (
            <button
              onClick={() => handlePopupShowDevice(item)}
              className="btn btn-warning"
            >
              Hiển thị thiết bị
            </button>
          ) : (
            <></>
          )}
        </Tooltip>

      </Box>
    ),
  };

  if (status === dataStateType.ACTIVE) {
    return [...columns, customerStatus, actionCol];
  }

  return columns;
};

export default GetCustomerColumns;
